import { render, staticRenderFns } from "./breakdownManagement.vue?vue&type=template&id=0d1fe0b3&scoped=true"
import script from "./breakdownManagement.vue?vue&type=script&lang=js"
export * from "./breakdownManagement.vue?vue&type=script&lang=js"
import style0 from "./breakdownManagement.vue?vue&type=style&index=0&id=0d1fe0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fe0b3",
  null
  
)

export default component.exports